export enum USER_PERMISSION {
  VIEW_USER = "view_user",
  ADD_USER = "add_user",
  CHANGE_USER = "change_user",
  DELETE_USER = "delete_user",

  VIEW_TEAM = "view_team",
  ADD_TEAM = "add_team",
  CHANGE_TEAM = "change_team",

  VIEW_PIPELINE = "view_pipeline",
  CHANGE_PIPELINE = "change_pipeline",
  ADD_PIPELINE = "add_pipeline",
  DELETE_PIPELINE = "delete_pipeline",

  VIEW_SYSTEM_SETTINGS = "view_systemsettings",
  CHANGE_SYSTEM_SETTINGS = "change_systemsettings",
  VIEW_API_KEY = "view_apikey",
  //- TODO: UPDATE FOLLOWING BE: https://cinnamon-ai.atlassian.net/browse/FSH2410-394
  VIEW_LICENSE_TENANT = "view_licensetenant",
  ADD_API_KEY = "add_apikey",
  CHANGE_API_KEY = "change_apikey",
  DELETE_API_KEY = "delete_apikey",

  VIEW_IP_WHITELIST = "view_ip_whitelist",
  CHANGE_IP_WHITELIST = "change_ip_whitelist",

  VIEW_PIPELINE_STATISTIC = "view_pipelinestatistic",

  VIEW_WORKFLOW = "view_workflow",
  ADD_WORKFLOW = "add_workflow",
  CHANGE_WORKFLOW = "change_workflow",
  DELETE_WORKFLOW = "delete_workflow",

  VIEW_JOB = "view_job",
  CHANGE_JOB = "change_job",

  RERUN_ERROR_JOB = "change_jobresultlock",
  RETRY_JOB = "retry_job",
}
